import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchErr } from 'src/app/shared/utils';
import { IndicadorInfo, DashboardIndicadores } from '../../dashboard.model';
import { DashboardIndicadoresAnuaisService } from 'src/app/dashboard/sessoes/dashboard-anual/dashboard-indicadores-anuais.service';

@Component({
    selector: 'app-dashboard-indicadores-anuais',
    templateUrl: './dashboard-indicadores-anuais.component.html',
    styleUrls: ['./dashboard-indicadores-anuais.component.css'],
    standalone: false
})
export class DashboardIndicadoresAnuaisComponent implements OnInit {
    loading = false;
    indicadoresAnuais: IndicadorInfo[] = [];

    constructor(
        private service: DashboardIndicadoresAnuaisService,
        private snackBar: MatSnackBar
    ) {}

    ngOnInit(): void {
        this.fetchIndicadores();
    }

    private fetchIndicadores(): void {
        this.loading = true;
        this.service.getIndicadoresAnuais().subscribe({
            next: (anuais: DashboardIndicadores) => {
                this.indicadoresAnuais = [
                    {
                        titulo: 'Criados',
                        valor: anuais.criados,
                        icone: 'add_circle',
                        cor: 'primary',
                        descricao: 'Quantidade total de DIOs criados no ano vigente',
                        periodicidade: 'Anual'
                    },
                    {
                        titulo: 'Executados',
                        valor: anuais.executados,
                        icone: 'check_circle',
                        cor: 'success',
                        descricao: 'Quantidade de DIOs executados pelos condutores no ano vigente',
                        periodicidade: 'Anual'
                    },
                    {
                        titulo: 'Não Executados',
                        valor: anuais.naoExecutados,
                        icone: 'cancel',
                        cor: 'warn',
                        descricao: 'Quantidade de DIOs não executados pelos condutores no ano vigente',
                        periodicidade: 'Anual'
                    },
                    {
                        titulo: 'Executor',
                        valor: anuais.executor,
                        icone: 'pending_actions',
                        cor: 'accent',
                        descricao: 'Quantidade de DIOs pendentes de atesto do Funcionário no ano vigente',
                        periodicidade: 'Anual'
                    },
                    {
                        titulo: 'Aferição',
                        valor: anuais.afericao,
                        icone: 'assessment',
                        cor: 'primary',
                        descricao: 'Quantidade de DIOs pendentes de aferição no ano vigente',
                        periodicidade: 'Anual'
                    },
                    {
                        titulo: 'Fiscal',
                        valor: anuais.fiscal,
                        icone: 'gavel',
                        cor: 'accent',
                        descricao: 'Quantidade de DIOs pendentes de validação do Fiscal no ano vigente',
                        periodicidade: 'Anual'
                    },                    
                ];
            },
            error: (err: any) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);
    }

    getCorClasse(cor: string): string {
        const cores: { [key: string]: string } = {
            'primary': 'text-primary',
            'success': 'text-success',
            'warn': 'text-danger',
            'accent': 'text-warning'
        };
        return cores[cor] || 'text-primary';
    }
}
